import { LinkField } from "../../carlsberg-headless/types/fields/Link";

// TODO - remove when APIs return isDefault in Link's
const hardcodedDefaultCultureBasedOnUmbracoSettings = "en-us";

export const getLocalizedUrl = (
  link: LinkField,
  cultureKey: string
): string => {
  if (
    link.relativeUrl === "" ||
    link.relativeUrl === "da" ||
    (!link.url.startsWith("http") && !link.url.startsWith("#")) ||
    link.target === "_blank"
  ) {
    return link.url;
  }
  const beginsWithSlash = link.relativeUrl.startsWith("/");
  const isLocalized =
    cultureKey === hardcodedDefaultCultureBasedOnUmbracoSettings &&
    link.relativeUrl.includes(`${cultureKey}/`);

  const isUrlMissingLocale =
    cultureKey !== hardcodedDefaultCultureBasedOnUmbracoSettings &&
    !link.relativeUrl.includes(`${cultureKey}/`);

  return [
    ...(isUrlMissingLocale && !isLocalized ? ["/", cultureKey] : []),
    ...(!beginsWithSlash ? ["/"] : []),
    link.relativeUrl,
  ].join("");
};
